import React, {Component} from 'react';
import {connect} from 'react-redux';
import validate from 'validate.js';

import * as spActions from '../../actions/sp';
import AppNames from "../AppNames/AppNames";
import '../index.scss';
import {checkSession} from "../../api/api";
import * as messageConstants from '../../shared/messages';
import Message from "../Message";
import duplicates from 'array-duplicates';
import {
  MESSAGE_EVENT_TYPE
} from "../../constants/postMessages";
import {OIDC_APPLICATION} from "../../constants/applicationTypes.js";
import RedirectUris from "./RedirectUris/RedirectUris";
import ClientCredentials from "./ClientCredentials/ClientCredentials";
import * as idpActions from "../../actions/idp";
import OidcIdpMetadataPopup from "./IdpOidcMetadataPopup/OidcIdpMetadataPopup";
import CapabilitiesSection from "../AddSAML/CapabilitiesSection";
import {getExtendedAttributes, getMappedCapabilities} from "../../actions/storage";
import Scope from "./Claims/Scope";
import {
  NON_LDAP_EPIC_USERNAME,
  SID_GUID_FLEXIBLE_ATTRIBUTES,
  USER_EXTENDED_ATTRIBUTES
} from "../../constants/requiredCapabilitiesMapping";
import {EXTENDED_ATTRIBUTE, REGULAR_USER_ATTRIBUTES} from "../../constants/samlConstants";

export class OidcApp extends Component {
  state = {}
  handleFrameTasks = (e) => {
    console.log(e);
  }

  handleSaveSP = () => {
    let oidcProfile = null;

    if (this.props.oidcProfile && !this.state.spDataActive) {
      oidcProfile = this.props.oidcProfile;
    }
    oidcProfile.oidcRedirectUris = this.props.oidcRedirectUris.filter(
        e => e.redirectUri.length > 0);

    oidcProfile.oidcScope = this.props.oidcScope
        .map(scope => {
            let customClaims = scope.oidcCustomClaims
                .filter(claim => claim.oidcCustomClaimName.length > 0)
                .map(claim => {
                    if (!REGULAR_USER_ATTRIBUTES.includes(claim.idpUserAttributeEnum)) {
                        return {
                            ...claim,
                            "oidcCustomClaimValue": claim.idpUserAttributeEnum.toString(),
                            "idpUserAttributeEnum": EXTENDED_ATTRIBUTE
                        }
                    }
                    return claim;
                });
            return {
                ...scope,
                oidcCustomClaims: customClaims
            }
        }).filter(scope => scope.scopeName.length > 0 || scope.oidcCustomClaims.length > 0);
    const newMeta = {
      name: this.props.applicationName,
      userFriendlyName: this.props.userFriendlyName,
      applicationType: OIDC_APPLICATION,
      oidcProfile: oidcProfile,
      applicationId: this.props.applicationId
    }

    const constraints = {
      name: {
        presence: {
          allowEmpty: false,
          message: messageConstants.SBA_WARNING_BLANK_APPNAME
        }
      },
      userFriendlyName: {
        presence: {
          allowEmpty: false,
          message: messageConstants.SBA_WARNING_BLANK_USER_FRIENDLY_APPNAME
        }
      },
      oidcProfile: {
        presence: {
          allowEmpty: false,
          message: messageConstants.SBA_WARNING_BLANK_METADATA
        }
      },
    };
    const errors = validate(newMeta, constraints, {fullMessages: false});

    const duplicatedRedirectUri =
        duplicates(this.props.oidcProfile.oidcRedirectUris.slice().sort(),
            i => i.redirectUri).filter(i => i.redirectUri);
    const duplicatedClaims = duplicates([].concat.apply([], this.props.oidcProfile.oidcScope.map(scope =>
        scope.oidcCustomClaims.map(claim => claim.oidcCustomClaimName.toLowerCase()))));
    const duplicatedScope = duplicates(this.props.oidcProfile.oidcScope.map(scope => scope.scopeName.toLowerCase()));
    const emptyNameScope = this.props.oidcProfile.oidcScope.filter(scope => scope.scopeName.length === 0);

    if (errors) {
      this.setState({errors});
      this.props.setErrorMessage(errors[Object.keys(errors)[0]]);
    } else {
      if (duplicatedRedirectUri.length > 0) {
        this.props.setErrorMessage(messageConstants.OIDC_URI_IS_DUPLICATED);
      } else if (emptyNameScope.length > 0) {
        this.props.setErrorMessage(messageConstants.SCOPE_NAME_IS_EMPTY);
      } else if (duplicatedScope.length > 0) {
        this.props.setErrorMessage(duplicatedScope[0] + messageConstants.SCOPE_NAME_IS_DUPLICATED);
      } else if (duplicatedClaims.length > 0) {
        this.props.setErrorMessage(duplicatedClaims[0] + messageConstants.CLAIM_NAME_IS_DUPLICATED);
      } else {
        if (this.props.applicationId) {
          this.props.updateApp(newMeta);
        } else {
          this.props.addApp(newMeta);
        }
      }
    }
  }

  handleAddOidcCancel = () => {
    this.props.cancelAddApp();
  }

  handleEditApplication = () => {
    if (this.props.match.params.applicationId) {
      this.props.editAppId(this.props.match.params.applicationId);
    }
  }

  handleChangeAppName = (e) => {
    this.props.updateAppName(e.target.value);
  }
  handleChangeUserFriendlyName = (e) => {
    this.props.updateUserFriendlyName(e.target.value)
  }

  handleUserFriendlyNameBlur = () => {
    if (!this.props.userFriendlyName.length > 0) {
      this.props.updateUserFriendlyName(this.props.applicationName)
    }
  }

  handleGetIdpMetadata = () => {
    this.props.getIdpMetadata();
  }
  handleShowModalOidcIdpMetadata = () => {
    this.props.showOidcIdpMetadataPopup();
  }
  handleHideModalOidcIdpMetadata = () => {
    this.props.hideOidcIdpMetadataPopup()
  }
  generateOidcClientCredentials = () => {
    this.props.generateOidcClientCredentials(this.props.applicationId)
  }

  componentDidMount() {
    if (checkSession(this.props.history)) {
      window.addEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
      this.handleGetIdpMetadata();
      this.handleEditApplication();
    }
  }

  componentWillUnmount() {
    window.removeEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
  }

  render() {
    const {oidcScope} = this.props;
    const capabilities = JSON.parse(getMappedCapabilities());
    const extendedAttributes = JSON.parse(getExtendedAttributes());
    const displayFlexibleAttributes = capabilities ? capabilities[SID_GUID_FLEXIBLE_ATTRIBUTES] : false;
    const displayUserExtendedAttributes = capabilities ? capabilities[USER_EXTENDED_ATTRIBUTES] : false;
    const displayNonLdapEpicUsername = capabilities ? capabilities[NON_LDAP_EPIC_USERNAME] : false;
    const {oidcRedirectUris, clientId, clientSecret, applicationId} = this.props;
    return (
        <div className="AddApp-container">
          <div className="container">
            <Message successMessage={this.props.successMsg}
                     errorMessage={this.props.errorMsg}
                     clearMessages={this.props.clearMessages}/>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12">
                <div className="add-edit-title">{this.props.applicationId
                    ? messageConstants.OIDC_TITLE_EDIT
                    : messageConstants.OIDC_TITLE_ADD}</div>
                <div className="add-edit-subtitle">
                  {messageConstants.OIDC_SUBTITLE}
                </div>

                <AppNames applicationName={this.props.applicationName}
                          userFriendlyName={this.props.userFriendlyName}
                          handleChangeAppName={this.handleChangeAppName}
                          handleChangeUserFriendlyName={this.handleChangeUserFriendlyName}
                          handleUserFriendlyNameBlur={this.handleUserFriendlyNameBlur}/>

                <RedirectUris
                    oidcRedirectUris={oidcRedirectUris}
                    handleAddOidcRedirectUri={this.props.addOidcRedirectUri}
                    handleDelOidcRedirectUri={this.props.deleteOidcRedirectUri}
                    handleUpdateOidcRedirectUri={this.props.updateOidcRedirectUri}/>

                <h3 className="sba-subtitle">{messageConstants.CLAIMS_TITLE}</h3>
                <CapabilitiesSection capabilities={capabilities}>
                  <Scope
                      extendedAttributes={extendedAttributes}
                      displayUserExtendedAttributes={displayUserExtendedAttributes}
                      displayFlexibleAttributes={displayFlexibleAttributes}
                      displayNonLdapEpicUsername={displayNonLdapEpicUsername}
                      oidcScope={oidcScope}
                      addScope={this.props.addScope}
                      updateScope={this.props.updateScope}
                      deleteScope={this.props.deleteScope}
                      addClaimToScope={this.props.addClaimToScope}
                      deleteClaimFromScope={this.props.deleteClaimFromScope}
                      updateClaimInScope={this.props.updateClaimInScope}/>
                </CapabilitiesSection>

                &nbsp;
                <ClientCredentials
                    applicationId={applicationId}
                    clientId={clientId}
                    clientSecret={clientSecret}
                    generateOidcClientCredentials={this.generateOidcClientCredentials}/>
                &nbsp;

                <h3 className="sba-subtitle">{messageConstants.SBA_METADATA_REQUIRED_SP}
                </h3>

                <div className="add-edit-subtitle">
                  {messageConstants.SBA_OIDC_METADATA_REQUIRED_SP_DESCRIPTION}
                </div>
                <div className="view-idp-metadata-block">
                  <button id="showModalOidcIdpMetadataButton"
                          className="btn btn-link view-idp-metadata-button"
                          onClick={this.handleShowModalOidcIdpMetadata}>{messageConstants.OIDC_IDP_VIEW_AND_COPY_METADATA}
                  </button>
                </div>

                <OidcIdpMetadataPopup
                    showModalOidcIdpMetadata={this.props.showModalOidcIdpMetadata}
                    handleHideModalOidcIdpMetadata={this.handleHideModalOidcIdpMetadata}
                    idpMetadata={this.props.idpMetadata}/>

                <div className="action-row">
                  <button
                      id="cancelSaveOidcApplicationButton"
                      type="button"
                      className="btn btn-md cancel-save-button"
                      disabled={this.state.manualEntry}
                      onClick={this.handleAddOidcCancel}
                  >
                    {messageConstants.CANCEL}
                  </button>
                  &nbsp;
                  <button
                      id="saveOidcApplicationButton"
                      type="button"
                      className="btn btn-md btn-primary save-button"
                      disabled={!this.props.applicationName || !clientId
                          || !this.props.oidcRedirectUris.filter(e => e.redirectUri.length > 0).length > 0}
                      onClick={this.handleSaveSP}
                  >
                    {messageConstants.SBA_SAVE_BUTTON}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    credentials: state.auth.credentials,
    errorMsg: state.sp.errorMsg,
    oidcProfile: state.sp.oidcProfile,
    oidcRedirectUris: state.sp.oidcRedirectUris,
    clientId: state.sp.clientId,
    clientSecret: state.sp.clientSecret,
    signature: state.sp.signature,
    applicationId: state.sp.applicationId,
    applicationName: state.sp.applicationName,
    userFriendlyName: state.sp.userFriendlyName,
    idpMetadata: state.idp,
    showModalOidcIdpMetadata: state.idp.showModalOidcIdpMetadata,
    oidcScope: state.sp.oidcScope
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAppName: (e) => {
      dispatch(spActions.updateAppName(e))
    },
    updateUserFriendlyName: (e) => {
      dispatch(spActions.updateUserFriendlyName(e))
    },
    addApp: (metadata) => {
      dispatch(spActions.addOidc(metadata));
    },
    updateApp: (metadata) => {
      dispatch(spActions.updateApp(metadata));
    },
    cancelAddApp: () => {
      dispatch(spActions.cancelAddApp());
    },
    editAppId: (applicationId) => {
      dispatch(spActions.getApp(applicationId))
    },
    addOidcRedirectUri: () => {
      dispatch(spActions.addOidcRedirectUri());
    },
    deleteOidcRedirectUri: (attribute) => {
      dispatch(spActions.deleteOidcRedirectUri(attribute));
    },
    updateOidcRedirectUri: (evt) => {
      dispatch(spActions.updateOidcRedirectUri(evt));
    },
    clearMessages: () => {
      dispatch(spActions.clearMessages())
    },
    setErrorMessage: (errorMessage) => {
      dispatch(spActions.setErrorMessage(errorMessage))
    },
    getIdpMetadata: () => {
      dispatch(idpActions.getIdpMetadata());
    },
    showOidcIdpMetadataPopup: () => {
      dispatch(idpActions.showOidcIdpMetadataPopup());
    },
    hideOidcIdpMetadataPopup: () => {
      dispatch(idpActions.hideOidcIdpMetadataPopup());
    },
    generateOidcClientCredentials: (appId) => {
      dispatch(spActions.generateOidcClientCredentials(appId));
    },
    addScope: () => {
      dispatch(spActions.addScope());
    },
    updateScope: (updatedScopeIndex, updatedScope) => {
      dispatch(spActions.updateScope(updatedScopeIndex, updatedScope));
    },
    deleteScope: (scopeToDeleteIndex, scopeToDelete) => {
      dispatch(spActions.deleteScope(scopeToDeleteIndex, scopeToDelete));
    }
  }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OidcApp);



// WEBPACK FOOTER //
// ./src/components/OidcApp/index.js